import React, { useState, useEffect } from "react";

const HeroText = () => {
  const fullText = "Dados que transformam, estratégias que conectam";
  const [displayedText, setDisplayedText] = useState("");
  const [index, setIndex] = useState(0);
  const [deleting, setDeleting] = useState(false);

  useEffect(() => {
    const speed = deleting ? 150 : 60; // digita mais devagar, apaga mais rápido

    const timeout = setTimeout(() => {
      if (!deleting) {
        // escrevendo
        if (index < fullText.length) {
          setDisplayedText(fullText.slice(0, index + 1));
          setIndex((prev) => prev + 1);
        } else {
          // pausa ao final antes de apagar
          setTimeout(() => setDeleting(true), 1500);
        }
      } else {
        // apagando
        if (index > 0) {
          setDisplayedText(fullText.slice(0, index - 1));
          setIndex((prev) => prev - 1);
        } else {
          // pausa antes de recomeçar
          setDeleting(false);
        }
      }
    }, speed);

    return () => clearTimeout(timeout);
  }, [index, deleting]);

  return (
    <h3 style={{ display: "inline-block", maxWidth: "25vw", lineHeight: "1.4" }}>
      {displayedText}
      <span className="cursor">|</span>
    </h3>
  );
};

export default HeroText;
